import { shipmentPtlIndexValidate } from "../../application/dtos/shipment_ptl_index_validate";

export class shipmentPtlIndexEntity {
    constructor({id, unique_order_number, shipment_number, shipping_service, created_at, total, client_id, client, last_status}){
        this.id = id;
        this.unique_order_number = unique_order_number;
        this.shipment_number = shipment_number;
        this.shipping_service = shipping_service;
        this.created_at = created_at;
        this.total = total;
        this.client_id = client_id;
        this.client = client;
        this.last_status = last_status;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return shipmentPtlIndexValidate(this);
    }
}